import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import PageHeaderWithActionBar from '@/components/common/Header/PageHeaderWithActionBar.vue'
import MailList from '@mail/components/MailList.vue'
import WebMailBottom from '@/components/common/WebMailBottom.vue'
import api from '@mail/api'
import * as accountTypes from '@account/store/types'
import { mapGetters, mapMutations } from 'vuex'
import menues, { MenuInfo } from '@mail/components/menu'
import { DeleteMode } from '../types/enums'
import * as types from '@mail/store/types'
@Component({
    components: { PageHeaderWithActionBar, MailList, WebMailBottom },
    computed: {
        ...mapGetters({
            user: accountTypes.USER,
            selectList: types.EMAIL_SELECT
        })
    },
    methods: {
        ...mapMutations({
            selectEmailAll: types.EMAIL_SELECT_ALL,
            selectListClear: types.EMAIL_SELECT_CLEAR,
        })
    }
})
export default class HomeContainer extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    user!: account.User
    selectList!: string[]

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    selectEmailAll!: (ids: string[]) => void
    selectListClear!: () => void

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    unreadMailCount: number = 0
    unreadMailList: any[] = []
    hasUnreadMailFolder: any[] = []
    inboxId: string = ''

    /*더보기 2023-05-23*/
    offset: number = 0
    pageNumber: number = 1
    pageSize: number = 20
    loadMorePossible: boolean = true


    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    get menues(): MenuInfo[] {
        return menues
    }

    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //

    mountAction() {

        var promiseArr: Promise<any>[] = [
            api.folder.getFolderTree('')
        ]

        Promise.all(promiseArr).then(res => {
            this.hasUnreadMailFolder = res[0]['items']
            var folderId = ''
            for (var i = 0; i < this.hasUnreadMailFolder.length; i++) {
                var isDelete = false

                if(this.hasUnreadMailFolder[i]['name'] === '보낼 편지함' || this.hasUnreadMailFolder[i]['name'] === '임시 보관함' || this.hasUnreadMailFolder[i]['name'] === '정크 메일' ||this.hasUnreadMailFolder[i]['name'] === '지운 편지함')
                {
                    isDelete = true
                } 

                if(isDelete === true){
                    this.hasUnreadMailFolder.splice(i,1) 
                    i--

                }  else {
                    folderId += ',' + this.hasUnreadMailFolder[i]['id'] 
                }
            }
            
            this.offset = (this.pageNumber -1) * this.pageSize

            if (this.hasUnreadMailFolder.length) {
                api.mail.getUnreadMailList(folderId, this.pageSize, this.offset).then((res) => {
                    if(res.items.length) 
                    {
                        this.unreadMailCount = Number(res.totalCount || 0) //총 개수


                        if(this.pageNumber > 1) {
                            this.unreadMailList = [...(this.unreadMailList || []), ...res.items]
                        } else {
                            this.unreadMailList = res.items
                            this.isloading(false)
                        }
                        
                    } else 
                    {
                        this.unreadMailList = []
                        this.isloading(false)
                        this.loadMorePossible = false
                    }
                })
            }

        })

    }

    goInbox(hasAttachments: boolean) {
        if (this.inboxId) {
            if (hasAttachments) 
                this.$router.push({name: 'mail-list', params: {id: this.inboxId}, query: {hasAttachments: 'true'}})
            else
                this.$router.push({name: 'mail-list', params: {id: this.inboxId}})
        }
    }

    async deleteItems() {
        const ids = this.selectList

        if (await(window as any).confirmAsync(this.$t('M_Mail_Msg20').toString()) == false) {
            return false
        } else {
            api.mail.delete({ ids, mode: DeleteMode.MoveToDeletedItems}).then((succeed) => {
                if (succeed) {
                    ids.forEach((id: any) => {
                        const idx = this.unreadMailList.findIndex((e) => e.id === id);
                        const item = this.unreadMailList[idx];
                        item.deleted = true;
                    })
                    this.selectListClear()
                    this.mountAction()
                } else {
                    ids.forEach(async (id: any) => {
                        const idx = this.unreadMailList.findIndex((e) => e.id === id);
                        const item = this.unreadMailList[idx];
                        item.deleted = false;
                        await(window as any).alertAsync(this.$t('다시_시도해주시기_바랍니다').toString())
                    })
                }
            }).catch(() => {
                ids.forEach(async (id: any) => {
                    const idx = this.unreadMailList.findIndex((e) => e.id === id);
                    const item = this.unreadMailList[idx];
                    item.deleted = false;
                    await(window as any).alertAsync(this.$t('다시_시도해주시기_바랍니다').toString())
                })
            })
        }
    }

    async moveItems(folderId: string) {
        const ids = this.selectList

        if (await(window as any).confirmAsync('선택하신 메일을 이동하시겠습니까?') == false) {
            return false
        } else {
            api.mail.moveEmails(ids, folderId).then((succeed) => {
                if (succeed) {
                    ids.forEach((id: any) => {
                        const idx = this.unreadMailList.findIndex((e) => e.id === id);
                        const item = this.unreadMailList[idx];
                        item.deleted = true;
                    })
                    this.selectListClear()
                    this.mountAction()
                    this.$emit('moveModalClose')
                } else {
                    ids.forEach((id: any) => {
                        const idx = this.unreadMailList.findIndex((e) => e.id === id);
                        const item = this.unreadMailList[idx];
                        item.deleted = false;
                    })
                }
            }).catch(() => {
                ids.forEach((id: any) => {
                    const idx = this.unreadMailList.findIndex((e) => e.id === id);
                    const item = this.unreadMailList[idx];
                    item.deleted = false;
                })
            })
        }
    }

    readItems() {
        this.selectList.forEach(id => {
            api.mail.changeReadState(id, true)
        })
    }

    selectAll() {
        var ids: string[] = []
        this.unreadMailList.map(email => {
            ids.push(email.id)
        })
        this.selectEmailAll(ids)
    }

    //더보기 2023-05-23 추가
    loadMore() {
        if (this.loadMorePossible && this.unreadMailCount > 20) {
            this.pageNumber ++
            this.mountAction()
        }
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.isloading(true)
        this.mountAction()

        // 받은메일함 id
        api.folder.getFolderTree('').then(res => {
            this.inboxId = res.items.filter(x => x.wellKnownFolderName == 'inbox')[0].id
        })
    }
}
